<template>
    <div>
        <div class="prod_img">
        <div class="pizza_img image_prod">
            <img class="" :src="getbox_details.image">
        </div>
       </div>
    </div>
</template>
<script>
export default {
    name:'item_img_til',
    props:['getbox_details'],
}
</script>
<style lang="scss" scoped>
.pizza_img {
            border: 2px dashed gainsboro;
            position: relative;
            top: 40px;
            left: -160px;
            border-radius: 100%;
            width: 328px;
        }

        .prod_img {
            width: 200px;
            display: inline-block;
            float: left;
        }

        .pizza_img img {
            border-radius: 100%;
            transition: transform .8s cubic-bezier(.61, .01, .22, .98);
            width: 320px;
            height: 324px;
            object-fit: contain;
        }

        .pizza_Stor {
            transform: scale(1);
            border: none !important;
        }

        .pizza_Meduim {
            transform: scale(.86) rotate(-40deg);
        }

        .pizza_Liten {
            transform: scale(.76) rotate(-80deg);
        }

</style>